import './docReady';

/**
 * Classe esempio
 */
class Module {

    constructor() {
        docReady(() => {
            setTimeout(this.setHamburgerStatus, 10);
            setTimeout(this.enableSearch,20);
            // setTimeout(this.searchButtonAction,30);
        });
    }

    /**
     * 
     * @returns {undefined}
     */
    setHamburgerStatus() {
        /**
         * Inizializza l'hamburger menù
         * @type type
         */

        const $hamburger = document.querySelector('#hamburger-menu');

        if($hamburger) {
            $hamburger.classList.add('closed');
        }
    }

    /**
     * 
     */
    enableSearch() {

        const $searchButton_s = document.querySelectorAll('.icon.icon-search');
        const $searchForm = document.querySelector('.search-form');
        const $searchClose = document.querySelector('#search-close');
        const $searchIput = document.querySelector('input[name=s]');

        $searchButton_s.forEach(function ($searchButton) {
            $searchButton.addEventListener('click', function () {
                $searchForm.classList.toggle('active');
                $searchIput.focus();
            });
        });


        $searchClose.addEventListener('click', function () {
            $searchForm.classList.remove('active');
        })

        /*
        const $searchButton = document.querySelector('.icon.icon-search');

        if($searchButton) {
            // crea il form
            const $form = document.createElement('form');
            $form.setAttribute('action','/');
            $form.setAttribute('method','get');
            $form.setAttribute('class','search-form form active');
            $searchButton.appendChild($form);

            // crea input
            const $input = document.createElement('input');
            $input.setAttribute('type','text');
            $input.setAttribute('name','s');
            $input.setAttribute('class','form-control search');
            $form.appendChild($input);

            // crea input hidden
            const $inputHiddenCpt = document.createElement('input');
            $inputHiddenCpt.setAttribute('type','hidden');
            $inputHiddenCpt.setAttribute('name','post_type');
            $inputHiddenCpt.setAttribute('value','seatings,tables,complements');
            $form.appendChild($inputHiddenCpt);
        }
        */

    }

    /**
     * Azioni del pulsante search
     */
    searchButtonAction() {

        const $searchButton = document.querySelector('.icon.icon-search');

        if($searchButton) {
            const $form = document.querySelector('.search-form');
            const $search = $form.querySelector('.search');
            
            $searchButton.addEventListener('click', function (event) {
    
                // Don't follow the link
                event.preventDefault();
    
                // se è active, allora invia il form
                if ($searchButton.classList.contains('active')) {
                    // invia il form, se non è vuoto
                    if($search.value != '') {
                        $form.submit();
                    }
                } else {
                    // altrimenti aggiunge active
                    $searchButton.classList.add('active');
                }
    
            }, false);
        }

    }

}

// export
export default new Module();